// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"07aa973478e17be8","4044":"72cdaf3637ced5f0","4515":"07aa973478e17be8","4969":"4fe34d288d6d568f","5264":"c42f084ac2d5da69","8378":"2502ed62b60dce00"}[chunkId] + ".css";
};